'use strict';
import { get_stripe_config } from '../services/config.mjs';
import { get_subscription_plans } from '../services/stripe.mjs';
import { get_extension_packs } from '../services/traffic.mjs';
import { get_subscriptionplan_globalheader, get_subscriptionplan_card } from '../profile/helpers/subscriptions.mjs';
import { get_pack_card } from '../traffic/extension_packs.mjs';

let subscription_plans = null;
let starter_plan = null;
let stripe_config = null;
let app_config = null;
const inside_iframe = window.top !== window.self;
console.log(`Pricing page inside iframe? ${inside_iframe} `);
const prerender_elements = () => {
  let $ctnr = $('#app_container').empty();

  let $content = $(`
    <div class="info-container">
    </div>`);
  $content.append(getEmptySubscriptionPlans());
  $content.append(getEmptyExtensionPacks());
  $ctnr.append($content);
};

const getEmptySubscriptionPlans = () => {
  let $content = $(`
  <article class="slds-card">
    <div class="slds-card__header slds-grid">
      <header class="slds-media slds-media_center slds-has-flexi-truncate">
        <div class="slds-media__body">
          <h2 class="slds-card__header-title" style="display:inline-block;">
            Abonnements
          </h2>            
        </div>
      </header>
    </div>
    <div class="slds-card__body slds-card__body_inner">
      <div id="subscription_plans-card_body">
        <div style="height:5rem;">
          <div class="slds-align_absolute-center" style="height: 100%">
            <div role="status" class="slds-spinner slds-spinner_medium">
              <span class="slds-assistive-text">Loading</span>
              <div class="slds-spinner__dot-a"></div>
              <div class="slds-spinner__dot-b"></div>
            </div>
          </div>
        </div>
      </div>
      <div id="subscription_plan-details"></div>
    </div>
  </article>
  `);
  return $content;
};

const getEmptyExtensionPacks = () => {
  let $content = $(`
  <article class="slds-card">
    <div class="slds-card__header slds-grid">
      <header class="slds-media slds-media_center slds-has-flexi-truncate">
        <div class="slds-media__body">
          <h2 class="slds-card__header-title" style="display:inline-block;">
            Packs flux piéton
          </h2>            
        </div>
      </header>
    </div>
    <div class="slds-card__body slds-card__body_inner">
      <div id="extension-packs-body">
        <div style="height:5rem;">
          <div class="slds-align_absolute-center" style="height: 100%">
            <div role="status" class="slds-spinner slds-spinner_medium">
              <span class="slds-assistive-text">Loading</span>
              <div class="slds-spinner__dot-a"></div>
              <div class="slds-spinner__dot-b"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
  `);
  return $content;
};

const fetchSubscriptionPlans = async () => {
  const subscription_plans_resp = await get_subscription_plans();
  if (subscription_plans_resp.error) {
    console.error('Failed to fetch subscription plans', subscription_plans);
    return;
  }
  subscription_plans = subscription_plans_resp;
  renderSubscriptionPlans(subscription_plans);
};

const renderSubscriptionPlans = (subscription_plans) => {
  const subscription_plans_globalheader = get_subscriptionplan_globalheader(subscription_plans);
  let $content = $(`
  ${subscription_plans_globalheader}
  <p>Tous nos abonnements sont <b style="color: #2dc37d;">sans engagement</b>, et résiliables quand vous le souhaitez. Les prix indiqués sont valables à vie.</p>
  <div class="slds-grid slds-wrap slds-gutters">      
    ${subscription_plans
      .map((simu_plan) => {
        return `
    <div class="slds-col slds-size_1-of-1 slds-small-size_1-of-1 slds-medium-size_1-of-3 slds-m-vertical_small">
      ${get_subscriptionplan_card(simu_plan, { show_footer: true, starter_plan: starter_plan })}
    </div>`;
      })
      .join('')}
  </div>
  <div class="slds-align_absolute-center subcription-abbr slds-border_top slds-p-top_small">
  En souscrivant à un abonnement, vous acceptez les&nbsp;<a href="https://www.galigeo.com/easypoint/cgv/" target="_blank" style="text-decoration:underline;"> Conditions Générales de Ventes</a>.
  </div>`);
  $content.find('.subscription_plan-footer .slds-button[data-action="subscribe"]').removeClass('slds-hide');

  $content.find('.subscription_plan-footer button[data-action="subscribe"]').on('click', (e) => {
    const plan_id = $(e.currentTarget).parents('.subscription_plan-card').data('planid');
    const selected_plan = subscription_plans.find((s) => s.stripe_plan_id === plan_id);
    if (selected_plan) {
      const plan_label = selected_plan.label.toLowerCase();
      const target_url = `/registration?selected_plan=${plan_label}`;
      if (inside_iframe) {
        window.open(target_url, '_blank');
      } else {
        window.location.href = target_url;
      }
    }
  });
  $('#subscription_plans-card_body').empty().append($content);
};

const fetchExtensionPacks = async () => {
  const packs = await get_extension_packs();
  let $content = `
  <div>
    <p>Les packs d'extension de flux piéton ne sont disponibles que pour les abonnements Expert.</p>
  </div>
  <div class="slds-grid slds-wrap slds-gutters">      
    ${packs
      .map((pack) => {
        return `
    <div class="slds-col slds-size_1-of-1 slds-small-size_1-of-1 slds-medium-size_1-of-3 slds-m-vertical_small">
      ${get_pack_card(pack, { show_footer: false, is_traffic_available: false })}
    </div>`;
      })
      .join('')}
  </div>`;
  $('#extension-packs-body').empty().append($content);
};

const run = async () => {
  const { get_app_config } = await import('../services/config.mjs');
  app_config = await get_app_config();
  stripe_config = await get_stripe_config();
  starter_plan = stripe_config.products.find((p) => p.id === 'starter');
  prerender_elements();
  fetchSubscriptionPlans();
  fetchExtensionPacks();
};
run();
